import {Form, Formik} from 'formik';
import * as Yup from 'yup';
import FormikTextArea from '../../../components/formikFileds/textArea';
import CustomButton from '../../../components/customButton';
import UploadLogo from '../../../module/shop/form/logoUpload';
import UploadDocument from '../../../module/shop/form/documentUploader';
import DescriptionInformation from '../../../module/shop/form/descriptionInformation';
import {useNavigate} from 'react-router-dom';
import {useLab} from '../../../context/labContext';
import FormikSelect from '../../../components/formikFileds/select';
import {getYears} from '../../post/utility/getYears';
import {useEffect} from 'react';
import Header from '../../../components/header';
import useScrollToTop from '../../../utilities/hooks/scrollToTop/useScrollToTop';

interface IAddLabInformation {
  title: string;
  description: string;
  document: File | string | undefined;
  logo: File | string | undefined;
  establishment_year: string;
}

const AddSchema = Yup.object().shape({
  title: Yup.string().required('عنوان  اجباری می باشد'),
  description: Yup.string().required('توضیحات  اجباری می باشد'),
  establishment_year: Yup.string().required('تاریخ تاسیس اجباری می باشد'),
  document: Yup.mixed().required('عکس مجوز کسب و کار اجباری می باشد'),
});
const LabInformationForm = () => {
  useScrollToTop();

  const {lab, updateLabInfo} = useLab();
  const initialValues: IAddLabInformation = {
    title: lab?.title || '',
    description: lab?.about || '',
    document: lab?.license,
    logo: lab?.logo,
    establishment_year: lab?.establishment_year || '',
  };
  const navigate = useNavigate();

  useEffect(() => {
    if (!lab) {
      navigate('/lab/create/type');
    }
  }, [lab, navigate]);

  return (
    <>
      <Header title={'ایجاد آزمایشگاه'} />
      <div className="px-3 pb-4">
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={AddSchema}
          onSubmit={values => {
            updateLabInfo({
              about: values?.description,
              title: values?.title,
              logo: values?.logo,
              license: values?.document,
              establishment_year: values?.establishment_year,
            });
            navigate('/lab/edit/location');
          }}
        >
          {({setFieldValue, values, errors, touched}) => (
            <Form noValidate>
              <div className="mt-3">
                <div>
                  <FormikTextArea
                    name="title"
                    required
                    label="نام آزمایشگاه"
                    rows={3}
                    placeholder="مثلا:کشاورزی نوین"
                  />
                </div>
                <div className="mt-3">
                  <span>
                    درباره آزمایشگاه <span className="color-red-3">*</span>
                  </span>
                  <DescriptionInformation />
                  <FormikTextArea name="description" label="" rows={5} />
                </div>
                <div className="mt-3">
                  <UploadLogo
                    file={values.logo}
                    setFile={file => setFieldValue('logo', file)}
                  />
                </div>
                <div className="mt-3">
                  <UploadDocument
                    file={values.document}
                    setFile={file => setFieldValue('document', file)}
                    title="بارگذاری مجوز کسب و کار "
                    description="عکس مجوز کسب و کار خود را بارگذاری کنید."
                  />
                  {touched.document && errors.document && (
                    <>
                      <div className="pt-3">
                        <small className="color-red-1">
                          <i className="icon-warning"></i> {errors.document}
                        </small>
                      </div>
                    </>
                  )}
                </div>
                <div className="mt-4">
                  <FormikSelect
                    name="establishment_year"
                    label="تاریخ تاسیس"
                    Options={getYears(30)}
                    required
                  />
                </div>
              </div>
              <div className="mt-4">
                <CustomButton type="submit" title="ادامه" isLoading={false} />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default LabInformationForm;
